<template>
  <div class="xlcp">
    <div class="tips" id="tips"></div>
    <div class="list">
      <div>
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_bb88d32b1f04"
          path="pages/Home/home.html"
          style="
            width: 100px;
            height: 100px;
            position: absolute;
            left: 40px;
            outline: none;
            top: 40px;
          "
        >
          <script type="text/wxtag-template">
            <style>.btn {width: 80px;height: 100px;opacity:0}</style><button class="btn">手环测评</button>
          </script>
        </wx-open-launch-weapp>
        手环测评
      </div>
      <div @click="service">心理服务</div>
      <div @click="toReport">报告查询</div>
    </div>
    <div class="ewm">
      <dl>
        <dt>公众号二维码</dt>
        <dd>
          <img src="../assets/Integrated/codeL.png" alt="" />
        </dd>
      </dl>
      <dl>
        <dt>小程序二维码</dt>
        <dd><img src="../assets/Integrated/codeMini.png" alt="" /></dd>
      </dl>
    </div>
  </div>
</template>
<script>
import serivce from "@/utils/ajax";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      code: "",
      openid: "",
    };
  },
  created() {
    this.onClickOpens();
    this.init();
  },
  methods: {
    service() {
      window.location.href = `https://psych.lingximind.com/h5/index.html#/psyServe`;
    },
    onClickOpens() {
      serivce
        .get("/sp_api/sp/wxConfig", {
          appid: process.env.VUE_APP_BASE_APPID,
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          let data = res.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: process.env.VUE_APP_BASE_APPID, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            openTagList: ["wx-open-launch-weapp"],
            ignoredElements: ["wx-open-launch-app", "wx-open-launch-weapp"],
            jsApiList: [
              "checkJsApi",
              "scanQRCode",
              "getLocation",
              "wx-open-launch-weapp",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        });
    },
    async init() {
      var that = this;
      const isWechat = () => {
        return (
          String(navigator.userAgent.match(/MicroMessenger/i)) ===
          "micromessenger"
        );
      };
      function getWechatCode() {
        if (isWechat) {
          let appid = process.env.VUE_APP_BASE_APPID; //微信APPid
          let code = getUrlCode().code; //是否存在code
          let local = window.location.href;
          if (code == null || code === "") {
            //不存在就打开地址进行授权
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              appid +
              "&redirect_uri=" +
              encodeURIComponent(local) +
              "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
          } else if(!localStorage.getItem('openid') || localStorage.getItem('openid') == undefined){
            serivce
              .get(`/api/lxUser/openid`, {
                code: code,
              })
              .then((res) => {
                if (res.status == 200) {
                  let temp = JSON.parse(res.msg);
                  localStorage.setItem("openid", temp.openid);
                  that.openid = temp.openid;
                } else {
                  that.pupUp(res.msg);
                }
              });
          }else{
            that.openid = localStorage.getItem('openid')
          }
        }
      }

      function getUrlCode() {
        // 截取url中的code方法
        var url = location.search;
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
          var str = url.substr(1);
          var strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
          }
        }
        console.log(theRequest);
        return theRequest;
      }

      getWechatCode();
    },
    toReport() {
      this.$router.push({
        path: "/LookReport?openId=" + this.openid,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.xlcp {
  height: 100%;
  width: 100%;
  background: url(../assets/jxxlcp/bg.png) no-repeat #fff;
  background-size: 100% auto;
  padding-top: 0.72rem;
  .list {
    margin: 0 0.32rem 0.72rem;
    background: #fff;
    border-radius: 0.2rem;
    padding: 0.35rem 0;
    display: flex;
    justify-content: space-between;
    div {
      margin: 0;
      // width: 1.3rem;
      flex: 1;
      height: 1.2rem;
      background: url(../assets/jxxlcp/scale.png) no-repeat;
      background-position-x: center;
      background-size: 1.3rem auto;
      font-size: 0.24rem;
      color: #333333;
      font-weight: normal;
      display: flex;
      width: 100%;
      align-items: flex-end;
      justify-content: center;
    }
    div:nth-child(2) {
      background: url(../assets/jxxlcp/service.png) no-repeat;
      background-position-x: center;
      background-size: 1.3rem auto;
    }
    div:nth-child(3) {
      background: url(../assets/jxxlcp/report.png) no-repeat;
      background-position-x: center;
      background-size: 1.3rem auto;
    }
  }
}
.ewm {
  font-size: 0.32rem;
  display: flex;
  color: #3d3d3d;
  padding: 0 0.32rem 0 0;
  justify-content: space-between;
  dl {
    padding-left: 0.32rem;
    margin: 0;
    dt {
      font-size: 0.28rem;
      padding-bottom: 0.16rem;
    }
    dd {
      margin: 0;
      img {
        width: 3.27rem;
      }
    }
  }
}
</style>